/* Keep the mobile purchase area clear without closing an open chat or form.
   The theme controls when product information is in view; vendor UI is styled
   through Shopify Inbox's exported activator part and Klaviyo's teaser root. */
if (!customElements.get('purchase-widget-clearance')) {
  customElements.define('purchase-widget-clearance', class extends HTMLElement {
    connectedCallback() {
      if (this.observer || !window.IntersectionObserver) return;
      this.target = document.getElementById(this.dataset.target);
      if (!this.target) return;
      this.inView = false;
      this.onFocus = () => this.sync();
      this.target.addEventListener('focusin', this.onFocus);
      this.target.addEventListener('focusout', this.onFocus);
      this.observer = new IntersectionObserver((entries) => {
        this.inView = entries.some((entry) => entry.isIntersecting);
        this.sync();
      }, { rootMargin: '-80px 0px -90px 0px', threshold: 0 });
      this.observer.observe(this.target);
    }

    sync() {
      this.active = this.inView || this.target?.contains(document.activeElement);
      const active = Array.from(document.querySelectorAll('purchase-widget-clearance'))
        .some((controller) => controller.active);
      document.body.classList.toggle('pdp-purchase-active', active);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.observer = null;
      this.target?.removeEventListener('focusin', this.onFocus);
      this.target?.removeEventListener('focusout', this.onFocus);
      this.active = false;
      this.inView = false;
      const active = Array.from(document.querySelectorAll('purchase-widget-clearance'))
        .some((controller) => controller.active);
      document.body.classList.toggle('pdp-purchase-active', active);
    }
  });
}
